import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { AuthProvider } from "./auth/AuthContext";
import { RosterProvider } from "./data/RosterContext";
import { TagsProvider } from "./data/TagsContext";
import { router } from "./routes";
import "./styles/theme.css";

const root = document.getElementById("root");
if (!root) throw new Error("#root is missing from index.html");

createRoot(root).render(
  <StrictMode>
    <AuthProvider>
      <RosterProvider>
        <TagsProvider>
          <RouterProvider router={router} />
        </TagsProvider>
      </RosterProvider>
    </AuthProvider>
  </StrictMode>,
);
